// 彙整資料表
import * as types from '../actionType';

let initState = {
  dateData:{
    administrationFullTimeCount: [],
  barFullTimeCount: [],
  barManagementCount: [],
  barPartTimeCount: [],
  infieldFullTimeCount: [],
  infieldManagementCount: [],
  infieldPartTimeCount: [],
  outfieldFullTimeCount: [],
  outfieldManagementCount: [],
  outfieldPartTimeCount: [],
  time: []
},
  halfData: {
    administrationFullTimeCount: [],
  barFullTimeCount: [],
  barManagementCount: [],
  barPartTimeCount: [],
  infieldFullTimeCount: [],
  infieldManagementCount: [],
  infieldPartTimeCount: [],
  outfieldFullTimeCount: [],
  outfieldManagementCount: [],
  outfieldPartTimeCount: [],
  time: []
  },
  
};

function PeopleStatisticsState(state = initState, action) {
  switch (action.type) {
      case types.PEOPLESTATICTICS_SHEET_DETAIL_SUCCESS: {
        return action.result;
      }
      default:
        return state;
  }
}


export default PeopleStatisticsState;